import { render, staticRenderFns } from "./incoming_inventory.vue?vue&type=template&id=1c4ab636&scoped=true&"
import script from "./incoming_inventory.vue?vue&type=script&lang=js&"
export * from "./incoming_inventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4ab636",
  null
  
)

export default component.exports